/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

const homePageUrl = '/live/privilege/h5_medal_homepage'

// 公会勋章page http://wiki.xunlei.cn/pages/viewpage.action?pageId=92444117
export const h5MedalHomePageUnion = createAsyncThunk(
  'UnionTask3/h5MedalHomePageUnion',
  async (p: any, store: any) => {
    const resp = await http.post(homePageUrl, {
      ...store.getState().env.deviceinfo,
      ...p,
      medal_type: 1,
    })
    return resp.data
  }
)

// 主播勋章page http://wiki.xunlei.cn/pages/viewpage.action?pageId=92444117
export const h5MedalHomePageAnchor = createAsyncThunk(
  'UnionTask3/h5MedalHomePageAnchor',
  async (p: any, store: any) => {
    const resp = await http.post(homePageUrl, {
      ...store.getState().env.deviceinfo,
      ...p,
      medal_type: 2,
    })
    return resp.data
  }
)

// 勋章详情 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92444169
export const h5MedalDetail = createAsyncThunk(
  'UnionTask3/h5MedalDetail',
  async (p: any, store: any) => {
    const resp = await http.post('/live/privilege/h5_medal_detail', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export interface IMedal {
  wall_id: number
  name: string
  show_icon: string
  is_gained: boolean
}

interface HomeData {
  err_msg: string
  avatar: string
  name: string
  obtained_num: number
  obtained_list: Array<IMedal>
  un_obtained_list: Array<IMedal>
}

const initialState: {
  union: HomeData
  anchor: HomeData
} = {
  union: {
    err_msg: '',
    avatar: '',
    name: '',
    obtained_num: 1,
    obtained_list: [],
    un_obtained_list: [],
  },
  anchor: {
    err_msg: '',
    avatar: '',
    name: '',
    obtained_num: 12,
    obtained_list: [],
    un_obtained_list: [],
  },
}

export const UnionTask3Slice = createSlice({
  name: 'UnionTask3',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(h5MedalHomePageUnion.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        Object.assign(state.union, data)
      })
      .addCase(h5MedalHomePageAnchor.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        Object.assign(state.anchor, data)
      })
  },
})

export default UnionTask3Slice.reducer
